import React from 'react';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import { Link, withRouter } from "react-router-dom";
import './css/custom.css';
import { NavItem, NavLink, Nav, TabContent, TabPane } from 'reactstrap';
import { Spinner, Alert, UncontrolledAlert } from 'reactstrap';
import classnames from 'classnames';
import LoteCarga from './LoteCarga';
import { AppContext } from './../AppContext';
import ListaCarga from './ListaCarga';
import url from './variables/url.js';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
const local = url.localBack;
const fechaInicio = url.fechaInicio;
const fechaFin = url.fechaInicio;

const MySwal = withReactContent(Swal)

function importAll(r) {
	let images = {};
  r.keys().forEach((item, index) => { images[item.replace('./', '')] = r(item); });
	return images
}

const images = importAll(require.context('./icons', false, /\.(jpg|png|jpe?g|svg)$/));

const currentDate = new Date();

const options = [
  { value: '0', label: 'Todos' },
  { value: '1', label: 'Atendidas' },
  { value: '2', label: 'Parcialmente Atendidas' },
  { value: '3', label: 'Pendientes' }
]

const optionsDelegacion = [
  { value: '0', label: 'Todos' },
  { value: '1', label: 'Asignado' },
  { value: '2', label: 'Asignado a mí' }
]

function color_head() {
  return {
    backgroundColor: '#25223f',
    color: 'white',
    width: '20%', fontSize: 11,
  };
}
function color_head_desc(tipo) {
  if (tipo == 'medium') {
    return {
      backgroundColor: '#25223f',
      color: 'white', fontSize: 14,
      width: '15%'
    };
  } else if (tipo == 'd') {
    return {
      backgroundColor: '#25223f',
      color: 'white', fontSize: 11,
      width: '30%'
    }
  } else if (tipo == 'id') {
    return {
      backgroundColor: '#010053',
      color: 'white', fontSize: 12,
      width: '10%'
    };
  } else {
    return {
      backgroundColor: '#25223f',
      color: 'white', fontSize: 11,
      width: '10%'
    };
  }
}
//Funcion para colocar color a las celdasde la tabla
function color(rowIndex) {
  if (rowIndex % 2 === 0) {
    return {
      backgroundColor: 'white'
    };
  }
  return {
    backgroundColor: '#E7E7E7'
  };
}

const profes = [{ intIdPersona: 2069, strCedula: '1234', strNombre: 'Daniel', strApellido: 'Ochoa', strUnidad: 'Fiec' },
    { intIdPersona: 2, strCedula: '3333', strNombre: 'Diego', strApellido: 'Yance', strUnidad: 'Fimcp' }]

const fechaInicioSub = process.env.REACT_APP_FECHA_INICIO_SUB;
const fechaFinSub = process.env.REACT_APP_FECHA_FIN_SUB;

class ListadoProfesores extends React.Component {
  constructor(props) {
    super(props);
    let currentUser = this.context;
    this.state = { iduser: 0, profesores: [], next: false, validaciones: [], validacionesMut: [], noValidaciones: [], 
        activeTab: "2", aceptados: [], delegacion: {}, roles: [], notSC: false, populateFinish: false,
        bandera: false, banderaDec: false, banderaVice: false};
    
      this.toggle = this.toggle.bind(this);

      fetch(local + 'Validacion/Getapplaw', {
          method: 'GET'
      }).then(response => response.json())
          .then(data => {
              //console.log("leyes", data)
              //console.log("leyesInicio", data.fecha_inicio_sub)
              //console.log("leyesFin", data.fecha_fin_sub)
              let banSub = currentDate > this.changeFormat(data.fecha_inicio_sub) && currentDate < this.changeFormat(data.fecha_fin_sub)
              let banDec = currentDate > this.changeFormat(data.fecha_inicio_dec) && currentDate < this.changeFormat(data.fecha_fin_dec)
              let banVice = currentDate > this.changeFormat(data.fecha_inicio_vice) && currentDate < this.changeFormat(data.fecha_fin_vice)
              this.setState({ bandera: banSub, banderaDec: banDec, banderaVice: banVice })
          }).catch(function F(error) {
              console.log(error);
          });
    
  }

  componentDidMount() {
    let id = 0;
      let currentUser = this.context;
      //console.log('Mount',currentUser);
      if (currentUser != null) {
          //console.log(currentUser)
          this.setState({ iduser: currentUser.idpersona, roles: currentUser.roles });
          if (currentUser.roles.includes('SUBDECANO') || currentUser.roles.includes('COORDINADOR')) {
              this.populate(currentUser.idpersona);
          } else if (currentUser.roles.includes('DECANO')) {
              this.isDecano();
          } else if (currentUser.roles.includes('VICERRECTOR')) {
              this.isVicerrector(currentUser.idpersona);
          } else if (currentUser.roles.includes('ADMINISTRADOR')) {
              this.isAdministrador();
          }
          
    }      
    //console.log("id", id);    
  }

  componentDidUpdate() {
    let currentUser = this.context;
    //console.log('Update',currentUser);
    if(currentUser != null && this.state.iduser == 0){
      this.setState({ iduser: currentUser.idpersona, roles: currentUser.roles });
        if (currentUser.roles.includes('SUBDECANO') || currentUser.roles.includes('COORDINADOR')) {
            this.populate(currentUser.idpersona);
        } else if (currentUser.roles.includes('DECANO')) {
            this.isDecano();
        } else if (currentUser.roles.includes('VICERRECTOR')) {
            this.isVicerrector(currentUser.idpersona);
        } else if (currentUser.roles.includes('ADMINISTRADOR')) {
            this.isAdministrador();
        }
    }   
  }
  
    populate(idpersona) {
        MySwal.fire({
            icon: 'warning',
            title: 'Por favor espere!',
            html: 'Estamos procesando la consulta, esto puede tomar hasta 1 minuto.',// add html attribute if you want or remove
            allowOutsideClick: false,
            showCancelButton: false,
            showConfirmButton: false,
            onOpen: () => {
                Swal.showLoading()
            },
        })

    fetch(local + 'Validacion/GetProfesoresPorValidar/'+ idpersona, {
      method: 'GET'
    })
      .then(response => response.json())
      .then(data => {
          /*console.log(data);*/
          MySwal.close();
          this.setState({
              validaciones: data.validados,
              validacionesMut: data.validados, noValidaciones: data.noValidados,
              aceptados: data.validacionAceptada, delegacion: data.delegacion,
              populateFinish: true
          })
          
      })
      .catch(function F(error) {
        console.log(error);
      })
    }

    populateNotP(idpersona) {
        this.setState({ validaciones: ['No se porque logeaste'], notSC: true});
    }
  
  toggle(tab) {
    if (this.state.activeTab !== tab) this.setState({ activeTab: tab });
    }

    isDecano() {
        this.props.history.push({
            pathname: '/Decano',
        })
    }

    isVicerrector(idpersona) {
        this.props.history.push({
            pathname: '/Vicerrector',
        })
    }

    isAdministrador() {
        this.props.history.push({
            pathname: '/Administrador',
        })
    }

    changeFormat(fecha) {
        const date = fecha.split('T');
        //EXAMPLE
        //"2022-09-30"
        //"07:59:59"
        const [year, month, day] = date[0].split('-');
        const [hours, minutes, seconds] = date[1].split(':');

        var resp = new Date(+year, month - 1, +day, +hours, +minutes, +seconds);
        return resp;
    }

  render() {
    const currentUser = this.context;
      let currentDate = new Date();           

      let bandera = this.state.bandera;//currentDate > this.changeFormat(fechaInicioSub) && currentDate < this.changeFormat(fechaFinSub);
      let noacceso = <Alert>Ha finalizado la fecha maxima para el acceso a el sistema, no podra realizar cambios pero si consultar.</Alert>
    if(currentUser == null){
      return <><Spinner animation="grow" /></>;
    }else if(currentUser != null && this.state.iduser == 0){
      this.setState({iduser : currentUser.idpersona})      
    }
    
    const columns = [{
      dataField: 'strCedula',
      text: 'C. Identidad',
      headerStyle: color_head_desc('id'),
      style: (cell, row, rowIndex, colIndex) => {
        return color(rowIndex)
      },
    }, {
      dataField: 'strNombreCompleto',
      text: 'Nombre / Apellido',
      headerStyle: color_head_desc('id'),
      style: (cell, row, rowIndex, colIndex) => {
        return color(rowIndex)
      },
    }, {
      dataField: 'strUnidad',
      text: 'Unidad',
      hidden: true,
      headerStyle: color_head_desc('id'),
      style: (cell, row, rowIndex, colIndex) => {
        return color(rowIndex)
      },
    }, {
      dataField: 'totalObservaciones',
      isDummyField:true,
      text: 'Total de observaciones',
      headerStyle: color_head_desc('id'),
      align: 'center',
      style: (cell, row, rowIndex, colIndex) => {
        return color(rowIndex)
      },
      formatter: (cell, row, rowIndex) => {
        return(
          <div>
            {row['accionesIngresadas']} / {row['cantAcciones']}
          </div>
          
        )
      }
    }, {
      text: 'Revisar observaciones',
      isDummyField: true,
      datafield: 'vald',
      align: 'center',
      headerStyle: color_head_desc('id'),
      style: (cell, row, rowIndex, colIndex) => {
        return color(rowIndex)
      },
      formatter: (cellContent, row, rowIndex) => {
        return (

          <Link
            style={{ display: "block", margin: "1rem 0" }}
            to={`/profesor/${row.intIdPersona}`}
            key={row.intIdPersona}
          >
            <img src={images['edit.png'].default} alt="edit" width="30px" height="30px"/>
          </Link>

        )
      }
    }];

    const columnsNotValidate = [{
      dataField: 'nombres',
      text: 'Nombre / Apellido',
      headerStyle: color_head_desc('id'),
      style: (cell, row, rowIndex, colIndex) => {
        return color(rowIndex)
      },
    }, {
      dataField: 'numeroIdentificacion',
      text: 'Número de identificación',
      headerStyle: color_head_desc('id'),
      style: (cell, row, rowIndex, colIndex) => {
        return color(rowIndex)
      },
    },
    ];
  
    // let delegacion;
    // console.log('alola')
    // console.log(this.state.delegacion);
    // if(this.state.delegacion === null || Object.keys(this.state.delegacion).length ===0){
    //   console.log('entro?');
    //   delegacion = <></>;
    // }else{
    //   console.log(this.state.delegacion);
    //   delegacion = <Delegacion delegacion={this.state.delegacion} />;
    // }
    let validacionCard;
      let validacionList = <><h1>Alola</h1></>;
      if ((this.state.validaciones === null || Object.keys(this.state.validaciones).length === 0) && !this.state.populateFinish) {
      validacionCard = <><Spinner animation="grow" /></>;
      validacionList = <><Spinner animation="grow" /></>;
      } else if ((this.state.validaciones === null || Object.keys(this.state.validaciones).length === 0) && this.state.populateFinish) {
          validacionCard = <UncontrolledAlert color="warning">
              <h6 style={{ paddingLeft: "20px" }}>  <img src={images['notificacion.svg'].default} alt="alert" style={{ width: "20px", height: "20px" }} /> INFORMACIÓN</h6>
              <div style={{ textAlign: 'center' }}>Actualmente no posee Carga para validar.</div>
          </UncontrolledAlert>;
          validacionList = <UncontrolledAlert color="warning">
              <h6 style={{ paddingLeft: "20px" }}>  <img src={images['notificacion.svg'].default} alt="alert" style={{ width: "20px", height: "20px" }} /> INFORMACIÓN</h6>
              <div style={{ textAlign: 'center' }}>Actualmente no posee Carga para validar.</div>
          </UncontrolledAlert>;
      } else if (this.state.notSC) {
        validacionCard = <Alert>Usted no Posee el rol de Subdecano o Coordinador de Carrera.</Alert>;
        validacionList = <Alert>Usted no Posee el rol de Subdecano o Coordinador de Carrera.</Alert>;
    }else {
     /* console.log(this.state.validaciones);*/
      validacionCard = 
      <>
        <div className="py-1">                  
           <LoteCarga carga={this.state.validacionesMut} rol={currentUser.roles} location ={this.props.location}/>
        </div>
      </>;
      validacionList = <><div className="py-1">                  
      <ListaCarga carga={this.state.validacionesMut} rol={currentUser.roles} location ={this.props.location}/>
        </div></>;        
      }      
      
    return (
      <>
        <div>
        {!bandera ? noacceso : <></>}
        <div className="d-flex flex-row align-items-center py-1">
        <h3><label style={{ color: '#243165', fontWeight: 'bold'}} > Cargas a revisar </label></h3>
        </div>
          <Nav tabs>
            {/* { this.state.delegacion && 
            <NavItem>
              <NavLink className={classnames({ active: this.state.activeTab === '4' })} onClick={() => this.toggle('4')}>
                Delegación
              </NavLink>
            </NavItem>} */}
            <NavItem>
              <NavLink className={classnames({ active: this.state.activeTab === '2' }) + ' imgHeader'} onClick={() => this.toggle('2')}>
                <img src={this.state.activeTab === '2' ? images['Lista.svg'].default : images['Lista(G).svg'].default} alt="list" />
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink className={classnames({ active: this.state.activeTab === '1' }) + ' imgHeader'} onClick={() => this.toggle('1')}>
                <img src={images['Cartillas.svg'].default} alt="card" />
              </NavLink>
            </NavItem>
          </Nav>
          <TabContent activeTab={this.state.activeTab}>
            <TabPane tabId="1">
              {validacionCard}              
            </TabPane>
            <TabPane tabId="2">
              {validacionList}              
            </TabPane>
            </TabContent>
            {/* {this.state.delegacion && <TabPane tabId="4">
              {delegacion}
            </TabPane>} */}
        </div>
      </>

    );
  }
}
ListadoProfesores.contextType = AppContext;
export default withRouter(ListadoProfesores);